// v2/services/inscripcion.service.js
//
// Cliente API para los endpoints de inscripción online v2.
//
// Flujo típico desde el frontend:
//   1. validarInscrito({rut})              — bloquea si TV no responde
//   2. cotizar({items, datosCliente})       — devuelve hash + total
//   3. reservar({hash})                     — reserva atómica de cupos
//   4. iniciarPago({hash, returnUrl, ...})  — devuelve token + url Webpay
//   5. (Webpay redirect → returnUrl)
//   6. returnPago({tokenWs})                — confirma y crea inscripción

import { v2Post, v2Get } from './client.js';

const BASE = '/v2/inscripcion';

const InscripcionV2 = {
  /**
   * POST /v2/inscripcion/validar-inscrito
   * @param {string} rut "12345678-9"
   * @returns {Promise<{esVecino, estado, validacionId, mensaje}>}
   */
  validarInscrito: async (rut) => {
    const r = await v2Post(`${BASE}/validar-inscrito`, { rut });
    return r.data || r;
  },

  /**
   * POST /v2/inscripcion/cotizar
   * @param {object} payload
   * @param {Array}  payload.items - [{tipo:'taller', taller, horario, plan, inscrito}, ...]
   * @param {object} payload.datosCliente - { nombre, rut, email, telefono, ... }
   * @param {string} [payload.carritoId]
   * @returns {Promise<{hash, total, items, expiraEn, cotizacionId}>}
   */
  cotizar: async (payload) => {
    const r = await v2Post(`${BASE}/cotizar`, payload);
    return r.data || r;
  },

  /**
   * POST /v2/inscripcion/reservar
   * @param {string} hash hash de la cotización
   * @returns {Promise<{reservas: [{horarioId, reservaId, cuposDisponibles}]}>}
   */
  reservar: async (hash) => {
    const r = await v2Post(`${BASE}/reservar`, { hash });
    return r.data || r;
  },

  /**
   * POST /v2/inscripcion/iniciar-pago
   * @param {object} payload
   * @param {string} payload.hash
   * @param {string} payload.returnUrl
   * @param {object} payload.datosCliente
   * @returns {Promise<{token, url, ordenCompraId, pagoId, numeroOrden}>}
   */
  iniciarPago: async (payload) => {
    const r = await v2Post(`${BASE}/iniciar-pago`, payload);
    return r.data || r;
  },

  /**
   * GET /v2/inscripcion/pago/return?token_ws=...
   * Endpoint idempotente — la 2da llamada con mismo token retorna cache.
   * @returns {Promise<{estado, pagoId, ordenCompraId, inscripcionIds, motivo?}>}
   */
  confirmarPago: async (tokenWs) => {
    const r = await v2Get(`${BASE}/pago/return`, { params: { token_ws: tokenWs } });
    return r.data || r;
  }
};

export default InscripcionV2;
